import {React} from 'react'

const Experience = () => {
    return (
        <>
            <div className="experience" id="experience">
                <h1 className='text-center my-4'>Experience</h1>
                <div className="experience-block row">
                    <div className="box1 col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                        <h4>2020-2021</h4>
                        <p>
                            In 2020, I took the first steps. So over the years, I have developed my first Web Programming work, which is popular in the IT world. I first tried Small Practices. then I did the Big Practices. After that I started working as a freelancer at upwork.com, freelanser.com, Fiverr.com. I got my first job in Upworda. After that I participated in Big Projects. I increased my level of knowledge. I increased my experience on the freecodecamp.com platform in order to increase my knowledge. JavaScript Skills
                        </p>
                    </div>
                    <div className="box2">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="box3 col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                        <div className="block1">
                            <h4>2021</h4>
                            <p>
                                I'm not mistaken in saying that 2021 is a lucky year for me. First of all, I got acquainted with React Js, TypeScript and did big projects on them. I also upgraded my Experience to the Middle Level. And I Didn't Stop Studying With That ...
                            </p>
                        </div>
                        <div className="block2">
                            <h4>2021-2022</h4>
                            <p>
                                The year 2022 was as I expected. At the beginning of this year, I started working as a Front End Mentor at Bir Zed IT Academy, one of the Programming Centers in our country. So far I am continuing my work here. And I’ve been involved in Big Projects.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Experience